<ion-header>
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content>

  <bloc-header-comp [compOptions]="{'title': blocHeaderTitle, 'isBackBtn': isBackBtn, 'backTitle': blocHeaderBackTitle, 'url': blocHeaderBackUrl, navigate: 'root', loading: !pageLoaded}"></bloc-header-comp>

  <div class="ion-content-container parrainage">
    <div class="evs-card-ui" (click)="copyCode()">
      <div class="illu">
        <img src="assets/svg/illu-parrainage.svg" alt="EnVoitureSimone">
      </div>
      <div class="text">
        <p>Avec le code <span>{{parrainageCode}}</span> <img src="assets/svg/copy-icon.svg" alt="EnVoitureSimone">,<br *ngIf="isDesktop">tes amis bénéficient d'une réduction de {{parrainageCodeDiscount}}€ sur l'achat d'un <b>Pack Permis.</b></p>
        <p>Ils te disent merci !</p>
      </div>
    </div>
  </div>

</ion-content>

<ion-footer>
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>